import type { ReactElement } from 'react'
import { BandPicker } from 'app/components/action-center/BandPicker'
import type { ListView, SystemListBand, SystemListDef } from 'app/types/navigation'
import { useHandleSearchParams } from 'app/utils'
import { ALL_BANDS } from 'lib/systemLists'

export function ListBandPicker({
  def,
  band,
  view,
}: {
  def: SystemListDef
  band: SystemListBand | undefined
  view: ListView
}): ReactElement | null {
  const handleSearchParams = useHandleSearchParams()
  if (!def.bands) return null
  // One at a time works one band; only the board and table can show every band at once.
  const options = [
    ...(view === `focus`
      ? []
      : [
          {
            id: undefined,
            label: `Any time`,
            blurb: def.allBandBlurb ?? def.queue.strapline,
          },
        ]),
    ...def.bands.map((listBand) => ({
      id: listBand.id,
      label: listBand.label,
      blurb: listBand.queue.definition ?? listBand.label,
    })),
  ]
  if (options.length < 2) return null
  return (
    <BandPicker
      noun={def.bandNoun}
      menuLabel={def.bandMenuLabel ?? def.name}
      options={options}
      value={band?.id}
      onSelect={(id) => handleSearchParams({ band: id ?? ALL_BANDS, page: undefined })}
    />
  )
}
